import React from 'react';
export const LeftArrowSvg: React.FC = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L1.70711 8.29289C1.31658 8.68342 1.31658 9.31658 1.70711 9.70711L9 17"
        stroke="#4D525E"
        strokeWidth="2"
      />
    </svg>
  );
};
